"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auctions = void 0;
const client_1 = require("@arkecosystem/client");
class Auctions extends client_1.Resource {
    async getAllAuctions(query) {
        return this.sendGet("nft/exchange/auctions");
    }
    async getAuctionById(id) {
        return this.sendGet(`nft/exchange/auctions/${id}`);
    }
    async getAuctionsWallets(id) {
        return this.sendGet(`nft/exchange/auctions/${id}/wallets`);
    }
    async searchByAsset(payload, query) {
        return this.sendPost("nft/exchange/auctions/search", payload, query);
    }
    async getAllCanceledAuctions(query) {
        return this.sendGet("nft/exchange/auctions/canceled");
    }
    async getCanceledAuctionById(id) {
        return this.sendGet(`nft/exchange/auctions/canceled/${id}`);
    }
}
exports.Auctions = Auctions;
//# sourceMappingURL=auctions.js.map